import { useState } from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Field, useField } from 'formik';
import { important } from '../../../../utils/global/helper';
import Required from '../Required';

interface CheckboxInputProps {
  name: string;
  label: string;
  disabled?: boolean;
  required?: boolean;
}

function CheckboxInput({
  name,
  label,
  disabled,
  required,
}: CheckboxInputProps) {
  const [field] = useField(name);
  const [initialValue] = useState(field.value);

  return (
    <Box width="100%">
      <Field
        id={name}
        name={name}
        label={
          <Box flex="1" display="flex" alignItems="center" height="100%">
            <Typography variant="body2">{label}</Typography>
            {required && <Required />}
          </Box>
        }
        disabled={disabled}
        as={FormControlLabel}
        control={<Checkbox defaultChecked={!!initialValue} />}
        onBlur={undefined}
        sx={() => ({
          width: '100%',
          height: important('44px'),
          fontSize: '0.875rem',
        })}
      />
    </Box>
  );
}

export default CheckboxInput;
